module.exports = __webpack_public_path__ + "static/media/empty-account.83e4e4f9.svg";